import React from 'react'
import './Payge.css'
import axios from 'axios'
import { Helmet } from 'react-helmet'

import { API_URL } from '../../config'
import PaygeItem from '../../components/PaygeItem/PaygeItem'

const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"

const default_background = {
  urls: {
    full: '',
    small: '',
  },
  user: {
    name: "...",
    links: {html: "#"}
  }
}

export default class Payge extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoaded: false,
      paygeData: undefined,
      isBackgroundLoaded: false
    }
  }

  componentWillMount() {
    let paygeID = this.props.match.params.payge_id
    // showing loading indicator
    this.setState({isLoaded: false})
    console.log(paygeID)
    // getting payge details
    axios(`${API_URL}/payge/${paygeID}`)
      .then((result) => {
        if (result.status === 200) {
          if (result.data.status === "success") {
            document.title = `${result.data.payge.paygeDetails.name} - Payge`
            this.setState({
              paygeData: result.data.payge,
              isLoaded: true
            })
            // setting up google analytics
            if (result.data.payge.paygeDetails.gAnalyticsTrackingId) {
              this.setupGoogleAnalyticsForUser(result.data.payge.paygeDetails.gAnalyticsTrackingId)
            }
            // loading the background 
            const img = new Image()
            img.src = result.data.payge.backgroundImage.urls.full
            img.onload = () => {
              this.setState({
                isBackgroundLoaded: true
              })
            }
            // end of loading
          }
        }
      })
  }

  // Adding Google Analytics with User's tracking Id
  setupGoogleAnalyticsForUser(gAnalyticsTrackingId) {
    // adding scripts
    const script = document.createElement("script")
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gAnalyticsTrackingId}`
    script.async = true
    document.body.appendChild(script)
    
		const gScriptTag = document.createElement("script")
    gScriptTag.innerHTML = 
    `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gAnalyticsTrackingId}');
    `
    gScriptTag.async = true
    document.body.appendChild(gScriptTag)
  }

  render() {
    const { isLoaded, paygeData, isBackgroundLoaded } = this.state

    let theme = 'one'
    // getting payge data
    let background = default_background
    let name = undefined
    let description = undefined
    let driveFile = undefined
    let dropboxFile = undefined
    let isPaid = false
    let paymentDetails = undefined
    let paygeId = ''
    if (paygeData) {
      background = paygeData.backgroundImage
      name = paygeData.paygeDetails.name
      description = paygeData.paygeDetails.description
      // getting the correct download file
      driveFile = paygeData.driveFile
      dropboxFile = paygeData.dropboxFile
      paygeId = paygeData.id
      // getting theme
      theme = paygeData.paygeDetails.theme
      if (paygeData.isPaid) {
        isPaid = paygeData.isPaid
        paymentDetails = paygeData.paymentDetails
      }
    }

    let app_styles = 'app'
    if (theme === 'three') {
      app_styles = 'app app-three'
    }
    let pageTitle = 'Loading'
    if (name) { pageTitle = name }

    let paygeItem = (
      <PaygeItem 
        theme={theme} 
        isLoaded={isLoaded} 
        name={name} 
        description={description} 
        driveFile={driveFile}
        dropboxFile={dropboxFile}
        paygeId={this.props.match.params.payge_id}
        isPaid={isPaid}
        background={background}
        paymentDetails={paymentDetails} />
    )

    return (
      <div className={`${app_styles}`}>

        <Helmet>
          <title>{`${pageTitle} — Payge`}</title>
          <meta property="og:title" content={`${name} — Payge`} />
          <meta property="og:description" content={description} />
          <meta property="og:site_name" content="Payge" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://payge.io/${paygeId}`} />
          <meta property="og:image" content={background.urls.thumb} />
        </Helmet>

        <img src={isBackgroundLoaded ? background.urls.full : background.urls.thumb} className="bg-img" />
        <div className="img-attribution">
          <span>
            Photo by <a href={`${background.user.links.html}?utm_source=payge&utm_medium=referral`} target="_blank">{background.user.name}</a> on <a href="https://unsplash.com/?utm_source=payge&utm_medium=referral" target="_blank">Unsplash</a>
          </span>
        </div>
        {
          theme === "one" ? (
            <div className="payge-item">
              {paygeItem}
            </div>
          ) : (<>{paygeItem}</>)
        }
      </div>
    )
  }

}